import React, {ReactNode, useCallback} from 'react';
import {some, isEmpty, map} from 'lodash';
import classNames from 'classnames';
import {useDispatch, useSelector} from 'react-redux';

import {useMediaQuery} from 'src/hooks/useMediaQuery';
import {newWorkExperience, editWorkExperience} from 'shared/portfolio/actions/work-experiences';
import {Store} from 'src/types/store';

import TwoColumnMasonry from 'shared/portfolio/components/two-column-masonry';
import Card from '../card';
import Section from '../section';
import PortfolioSectionHeader from '../portfolio-section-header';
import EmptyPlaceholder from '../empty-placeholder';
import WorkExperience from './work-experience';
import WorkExperienceFormCard from 'shared/portfolio/components/work-experiences/work-experience-form-card';
import PortfolioIcon from '../portfolio-icon/portfolio-icon';

const WorkExperiences = () => {
  const mq = useMediaQuery();
  const dispatch = useDispatch();
  const workExperiences = useSelector((state: Store) => state.workExperiences);
  const editing = some(workExperiences, 'editing');
  const handleAddClick = useCallback(() => dispatch(newWorkExperience()), [dispatch]);

  let workExperienceItems: ReactNode = null;

  if (isEmpty(workExperiences)) {
    workExperienceItems = (
      <div className="portfolio-sections column">
        <EmptyPlaceholder
          onClick={handleAddClick}
          header="Add Work Experience"
          description="Up to $1,000 per year"
          className="work-experiences empty-placeholder"
          portfolioItemType="work-experience"
        />
      </div>
    );
  } else {
    workExperienceItems = (
      <TwoColumnMasonry>
        {map(workExperiences, (experience) => {
          if (experience.editing) {
            return (
              <div
                className={classNames('portfolio-sections column', {
                  editing: experience.editing,
                })}
                key={experience._id}
              >
                <WorkExperienceFormCard workExperience={experience} />
              </div>
            );
          } else {
            return (
              <div className="portfolio-sections column" key={experience._id}>
                <Card
                  id={experience._id}
                  onClick={() => {
                    dispatch(editWorkExperience(experience));
                  }}
                >
                  <WorkExperience workExperience={experience} />
                </Card>
              </div>
            );
          }
        })}
      </TwoColumnMasonry>
    );
  }

  return (
    <div>
      <PortfolioSectionHeader
        title="Work Experience"
        displayNew={!editing && !(mq.XS && !Object.keys(workExperiences).length)}
        addNew={handleAddClick}
        sectionName="work-experiences"
      >
        <PortfolioIcon type="workExperiences" size={mq.XS ? 40 : 56} />
      </PortfolioSectionHeader>
      <Section>
        <div id="work-experience" className="portfolio-sections main-section"></div>
        {workExperienceItems}
      </Section>
    </div>
  );
};

export default WorkExperiences;
